import {
  Box,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Spinner,
  Button,
  IconButton,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  Text,
  useToast,
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";
import { MdOutlineChevronRight, MdOutlineComment } from "react-icons/md";
import { FiCopy } from "react-icons/fi";
import React, { Fragment } from "react";
import AllFillters from "./Layout/AllFillters";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { Auth } from "./Auth";
import { IoMdFolderOpen } from "react-icons/io";
import Timeline from "./Timeline";

const AllOrder = ({ title, head, data, isLoading, refreshOrders }) => {
  const navigate = useNavigate();
  // const y = [...data].reverse()
  const [openArchiveConfirm, setOpenArchiveConfirm] = useState(false);
  const [isTimelineOpen, setIsTimelineOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [isMarkAsPaidOpen, setIsMarkAsPaidOpen] = useState(false);
  const [orderToMarkAsPaid, setOrderToMarkAsPaid] = useState(null);

  const displayedData = [...data].sort(
    (a, b) => new Date(b.placedDate) - new Date(a.placedDate)
  );

  const customerNameIndex = head.indexOf("Customer Name");
  const displayedHead =
    customerNameIndex >= 0 && !head.includes("Phone Number")
      ? [
          ...head.slice(0, customerNameIndex + 1),
          "Phone Number",
          ...head.slice(customerNameIndex + 1),
        ]
      : head;

  const toast = useToast();

  const copyPhoneNumber = async (phone) => {
    try {
      await navigator.clipboard.writeText(phone);
      toast({
        title: "Phone number copied",
        status: "success",
        duration: 2000,
        position: "top",
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Unable to copy phone number",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    }
  };

  // status str format
  const convertStatus = (str) => {
    // Split the string by underscores
    var words = str.split("_");

    // Capitalize the first letter of each word
    for (var i = 0; i < words.length; i++) {
      words[i] =
        words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase();
    }

    // Join the words with a space
    var result = words.join(" ");

    return result;
  };

  const nextLink = (order) => {
    const tenureId = order.OrderItem[0]?.TenureItem[0]?.tenureId;

    if (order.orderStatusId == "PAYMENT_PENDING") {
      if (tenureId) {
        return `/tenures/order/${order.id}/tenure/${tenureId}`;
      }
    }
    return `/orders/order/${order.id}`;
  };

  const handleStatusAction = (order) => {
    if (
      order.orderStatusId == "PAYMENT_PENDING" ||
      order.orderStatusId == "ENDED"
    ) {
      navigate(nextLink(order));
    }
  };
  
  const handleMarkAsPaid = async (order) => {
    const { id } = order;
    const data = JSON.stringify({
      "data": {
        "invoice": {
          "statusId": "PAID"
        }
      }
    });

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}/mark-as-active`,
      headers: { 
        'Content-Type': 'application/json'
      },
      data : data
    };

    axios.request(config)
    .then((response) => {
      console.log(JSON.stringify(response.data));
      toast({
        title: "Invoice marked as paid",
        status: "success",
        duration: 3000,
        position: "top",
        isClosable: true,
      });

      if (refreshOrders) {
        refreshOrders();
      }
    })
    .catch((error) => {
      console.log(error);
      toast({
        title: "Something went wrong please try again",
        status: "error",
        duration: 3000,
        position: "top",
        isClosable: true,
      });
    });
    setIsMarkAsPaidOpen(false);
  }

  const isExtended = (order) => {
    return order.OrderItem[0]?.TenureItem[0]?.tenure?.isExtended;
  };
  const [toArchiveOrder, setToArchiveOrder] = useState({});

  const toggleArchive = () => {
    const { id } = toArchiveOrder;
    if (!id) {
      return;
    }

    let data = JSON.stringify({
      orderId: `${id}`,
      isArchived: true,
    });

    let config = {
      method: "put",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_RALCO_API_URL}/api/order/${id}/mark-as-internal`,
      headers: {
        "Content-Type": "application/json",
        Authorization: Auth(),
      },
      data: data,
    };

    axios
      .request(config)
      .then((response) => {
        console.log(JSON.stringify(response.data));
        toast({
          title: "Order moved to archive",
          status: "success",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        toast({
          title: "Something went wrong please try again",
          status: "error",
          duration: 3000,
          position: "top",
          isClosable: true,
        });
      });
  };

  const commentsCount = (order) => {
    const count = order.OrderStatusHistory.filter(
      (x) => x.orderStatusToId === "ORDER_COMMENTED"
    ).length;
    return (
      <Flex
        style={{ visibility: count > 0 ? "visible" : "hidden" }}
        onClick={(e) => {
          e.preventDefault(); // Prevent Link navigation
          setSelectedOrder(order);
          setIsTimelineOpen(true);
        }}
        cursor="pointer"
      >
        <MdOutlineComment color={"#3182ce"} fontSize={"22px"} />
        <Text ml={2}>{count}</Text>
      </Flex>
    );
  };

  const [loadingLateFeeOrder, setLoadingLateFeeOrder] = useState(null);

  const toggleLateFeeApplicable = async (order, newStatus) => {
    if (loadingLateFeeOrder) {
      return;
    }
    setLoadingLateFeeOrder(order.id);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_RALCO_API_URL}/api/order/${order.id}/late-fee-applicable`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ lateFeeApplicable: newStatus }),
        }
      );
      const newData = data.map(d => d.id === order.id ? { ...d, lateFeeApplicable: newStatus } : d);
      if (response.ok) {
        refreshOrders(newData);
      } else {
        console.error("Failed to update late fee status");
      }
    } catch (error) {
      console.error("Error updating late fee status:", error);
    } finally {
      setLoadingLateFeeOrder(null);
    }
  };

  return (
    <Fragment>
      <AlertDialog
        isOpen={openArchiveConfirm}
        onClose={() => {
          setOpenArchiveConfirm(false);
        }}
        motionPreset="slideInBottom"
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Archive order
            </AlertDialogHeader>

            <AlertDialogBody>
              Are you sure? You can't undo this action afterwards.
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button
                colorScheme="red"
                onClick={() => {
                  toggleArchive();
                  setOpenArchiveConfirm(false);
                }}
              >
                Yes
              </Button>
              <Button
                colorScheme="blue"
                onClick={() => {
                  setOpenArchiveConfirm(false);
                }}
                ml={3}
              >
                No
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <AlertDialog
        isOpen={isMarkAsPaidOpen}
        onClose={() => setIsMarkAsPaidOpen(false)}
        motionPreset="slideInBottom"
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              Mark as Paid
            </AlertDialogHeader>

            <AlertDialogBody>
              <Text mb={3}>Are you sure you want to mark this order as paid?</Text>
              {orderToMarkAsPaid && (
                <Box p={3} bg="gray.50" borderRadius="md">
                  <Text><strong>Order ID:</strong> {orderToMarkAsPaid.OrderName}</Text>
                  <Text><strong>Customer:</strong> {`${orderToMarkAsPaid.customerParty?.firstName || '--'} ${orderToMarkAsPaid.customerParty?.lastName || '--'}`}</Text>
                  <Text><strong>Amount:</strong> Rs.{Number(orderToMarkAsPaid.grandTotal).toLocaleString('en-IN', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}</Text>
                  <Text><strong>Date:</strong> {new Intl.DateTimeFormat('en-US', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                    hour: 'numeric',
                    minute: 'numeric',
                    hour12: true,
                    timeZone: 'ASIA/KOLKATA',
                  }).format(new Date(orderToMarkAsPaid.placedDate))}</Text>
                </Box>
              )}
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={() => setIsMarkAsPaidOpen(false)}>Cancel</Button>
              <Button
                colorScheme="green"
                onClick={() => orderToMarkAsPaid && handleMarkAsPaid(orderToMarkAsPaid)}
                ml={3}
              >
                Confirm
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <Drawer
        isOpen={isTimelineOpen}
        placement="right"
        onClose={() => {
          setIsTimelineOpen(false);
          if (refreshOrders) {
            refreshOrders();
          }
        }}
        size="md"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Comments & Timeline</DrawerHeader>
          <DrawerBody>
            {selectedOrder && (
              <Timeline
                orderData={selectedOrder}
                orderName={selectedOrder.OrderName}
              />
            )}
          </DrawerBody>
        </DrawerContent>
      </Drawer>
      <AllFillters
        title={title}
        data={displayedData}
        create={"Order"}
        // filters = {[{"Order Date":filterbyOrderDate}, {"Delivery Date":filterbyDeliveryDate}, {"Electronics":filterbyCategory}]}
        filters={[]}
      />
      <Box maxW={"full"} my={4}>
        {/* height={`${window.innerHeight - 244}px`} */}
        <TableContainer
          height={`${window.innerHeight - 244}px`}
          overflowY={"scroll"}
        >
          <Table variant={"simple"} size={"xs"}>
            <Thead
              bgColor={"gray.100"}
              position={"sticky"}
              top={"0px"}
              zIndex={"99"}
            >
              <Tr bgColor={"#E2DFDF"}>
                {displayedHead.map((h, i) => (
                  <Th
                    key={i}
                    fontSize={{
                      base: "xs",
                      md: "xs",
                      lg: "xs",
                      xl: "xs",
                      "2xl": "sm",
                    }}
                    py={3}
                    _first={{ paddingLeft: "20px" }}
                    color={"#25282B"}
                  >
                    {h}
                  </Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {displayedData.length > 0 ? (
                <>
                  {displayedData.map((d, i) => (
                    <Tr key={i} bgColor={"white"}>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                        pl={5}
                      >
                        {d?.OrderName.includes("#") ? d?.OrderName : "Draft"}
                      </Td>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                      >
                        {new Intl.DateTimeFormat("en-US", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                          hour: "numeric",
                          minute: "numeric",
                          hour12: true,
                          timeZone: "ASIA/KOLKATA",
                        }).format(new Date(d.placedDate))}
                      </Td>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                      >{`${d?.customerParty?.firstName || "--"} ${
                        d?.customerParty?.lastName || "--"
                      }`}</Td>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                      >
                        <Flex alignItems="center" gap={1}>
                          <Text>{d?.customerParty?.phone || "--"}</Text>
                          {d?.customerParty?.phone && (
                            <IconButton
                              aria-label={`Copy phone number ${d.customerParty.phone}`}
                              icon={<FiCopy />}
                              size="xs"
                              variant="ghost"
                              onClick={() =>
                                copyPhoneNumber(d.customerParty.phone)
                              }
                            />
                          )}
                        </Flex>
                      </Td>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                      >
                        {"Rs." +
                          Number(d?.grandTotal).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }) || "----"}
                      </Td>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                        pl={4}
                      >
                        {d.OrderItem.length}
                      </Td>
                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                        pl={4}
                      >
                        <Button
                          size={"xs"}
                          cursor={"default"}
                          colorScheme={
                            (d?.orderStatusId === "ORDER_CREATED" && "green") ||
                            (d?.orderStatusId === "ORDER_PUBLISHED" &&
                              "facebook") ||
                            (d?.orderStatusId === "ORDER_DRAFT" && "purple") ||
                            (d?.orderStatusId === "ORDER_VERIFIED" &&
                              "whatsapp") ||
                            (d?.orderStatusId === "ORDER_DELIVERED" &&
                              "yellow") ||
                            (d?.orderStatusId === "ORDER_CANCELED" && "red") ||
                            (d?.orderStatusId === "ORDER_OUT_FOR_DELIVERY" &&
                              "orange") ||
                            (d?.orderStatusId === "ORDER_TRANSIT" &&
                              "messenger") ||
                            (d?.orderStatusId === "ORDER_RETURNED" &&
                              "telegram") ||
                            (d?.orderStatusId ===
                              "ORDER_PENDING_FOR_FULFILLMENT" &&
                              "teal") ||
                            (d?.orderStatusId ===
                              "ORDER_READY_FOR_FULFILLMENT" &&
                              "linkedin") ||
                            (d?.orderStatusId === "ORDER_PICKED" && "pink") ||
                            (d?.orderStatusId === "TERMINATED" &&
                              "blackAlpha") ||
                            (d?.orderStatusId === "AWAITING_VERIFICATION" &&
                              "black") ||
                            (d?.orderStatusId === "COMPLETED" &&
                              "blackAlpha") ||
                            (d?.orderStatusId === "ACTIVE" && "whatsapp") ||
                            (d?.orderStatusId === "PAYMENT_PENDING" && "red") ||
                            (d?.orderStatusId === "ENDING_TOMORROW" &&
                              "yellow") ||
                            (d?.orderStatusId === "ENDED" && "blackAlpha") ||
                            (d?.orderStatusId === "EARLY_CLOSURE" &&
                              "blackAlpha")
                          }
                        >
                          {convertStatus(d.orderStatusId)
                            .split(" ")
                            .filter((d) => d !== "Order")
                            .join(" ")}
                          {["ORDER_DELIVERED", "ACTIVE"].includes(
                            d.orderStatusId
                          ) && isExtended(d)
                            ? " - Extended"
                            : ""}
                        </Button>
                      </Td>

                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                        py={3}
                      >
                        {d.lateFeeApplicable ? (
                          <Button
                            size="xs"
                            colorScheme="green"
                            bgColor="green.100"
                            variant="outline"
                            borderRadius="full"
                            p={1}
                            minW="auto"
                            mr={2}
                            onClick={() =>
                              toggleLateFeeApplicable(d, !d.lateFeeApplicable)
                            }
                            isLoading={loadingLateFeeOrder === d.id}
                          >
                            {loadingLateFeeOrder === d.id ? "" : "₹"}
                          </Button>
                        ) : (
                          <Button
                            size="xs"
                            variant="outline"
                            color="gray.400"
                            borderColor="gray.400"
                            borderRadius="full"
                            p={1}
                            minW="auto"
                            mr={2}
                            onClick={() =>
                              toggleLateFeeApplicable(d, !d.lateFeeApplicable)
                            }
                            isLoading={loadingLateFeeOrder === d.id}
                          >
                            {loadingLateFeeOrder === d.id ? "" : "₹"}
                          </Button>
                        )}
                        {d.salesChannelEnumId !== "RALCO_INTERNAL_TEST" && (
                          <Button
                            size={"xs"}
                            // bgColor={"#8BC34A"}
                            color={"black"}
                            onClick={() => {
                              setToArchiveOrder(d);
                              setOpenArchiveConfirm(true);
                            }}
                            style={{ margin: "0 5px" }}
                          >
                            <IoMdFolderOpen />
                          </Button>
                        )}

                        {d?.orderStatusId === "AWAITING_VERIFICATION" ? (
                          <>
                            <Link
                              to={`/verification/customer-verification-details/${d?.id}`}
                            >
                              <Button
                                size={"xs"}
                                bgColor={"#8BC34A"}
                                color={"white"}
                                _hover={{ bgColor: "#8BC34A", opacity: "0.9" }}
                                rounded={"full"}
                              >
                                Move to Verified
                              </Button>
                            </Link>
                          </>
                        ) : null}

                        {d?.orderStatusId === "PAYMENT_PENDING" ? (
                          <>
                            <Button
                              size={"xs"}
                              bgColor={"#8BC34A"}
                              color={"white"}
                              onClick={() => {
                                setOrderToMarkAsPaid(d);
                                setIsMarkAsPaidOpen(true);
                              }}
                              _hover={{ bgColor: "#8BC34A", opacity: "0.9" }}
                              rounded={"full"}
                            >
                              Mark as paid
                            </Button>
                          </>
                        ) : null}

                        {d?.orderStatusId === "ENDED" && (
                          <Button
                            size={"xs"}
                            bgColor={"skyblue"}
                            color={"white"}
                            onClick={() => handleStatusAction(d)}
                            _hover={{ bgColor: "#8BC34A", opacity: "0.9" }}
                            rounded={"full"}
                          >
                            Take to order
                          </Button>
                        )}
                      </Td>

                      <Td
                        fontSize={{
                          base: "xs",
                          md: "sm",
                          lg: "sm",
                          xl: "sm",
                          "2xl": "sm",
                        }}
                      >
                        <Flex>
                          {commentsCount(d)}
                          <Box
                            bgColor={"gray.200"}
                            rounded={"full"}
                            my="auto"
                            p={2}
                            mx={2}
                          >
                            <Link to={`/orders/order/${d?.id}`}>
                              {" "}
                              <MdOutlineChevronRight />{" "}
                            </Link>
                          </Box>
                        </Flex>
                      </Td>
                    </Tr>
                  ))}
                </>
              ) : (
                <Tr>
                  <Td></Td>
                  <Td></Td>
                  <Td></Td>
                  <Td>
                    {isLoading.loading === true ? (
                      <Spinner
                        thickness="4px"
                        speed="0.65s"
                        emptyColor="gray.200"
                        color="blue.500"
                        size="xl"
                        mt={4}
                      />
                    ) : isLoading.error === true ? (
                      <Text fontWeight={"semibold"} color={"red.500"}>
                        Oops we are facing some temporary issue with your
                        request
                      </Text>
                    ) : (
                      <Text fontWeight={"semibold"} color={"green.500"}>
                        NO {`${title.toUpperCase()}`} AVAILABLE
                      </Text>
                    )}{" "}
                  </Td>
                  <Td></Td>
                  <Td></Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </Box>
    </Fragment>
  );
};

export default AllOrder;
